import React from 'react';
import { Award, GraduationCap, Target } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img 
              src="https://images.pexels.com/photos/6922159/pexels-photo-6922159.jpeg" 
              alt="Vincent Acquaro - Professional Personal Trainer"
            />
          </div>
          <div className="about-text">
            <span className="section-label">About Vincent</span>
            <h2 className="section-title">
              Welcome to My Website
            </h2>
            <p className="about-description">
              My name is Vincent Michael Acquaro, and I'm an ISSA-certified personal trainer. 
              I've been training for over 10 years and I know first-hand how frustrating it can 
              be to spend years working hard without the right guidance.
            </p>
            <p className="about-description">
              It took me five years to realize that with the proper training and nutrition plan, 
              I could have reached my goals in a fraction of the time. That experience is why I'm 
              passionate about helping others cut through the confusion, simplify the process, and 
              get real results.
            </p>

            <div className="certifications-grid">
              <div className="cert-card">
                <div className="cert-icon">
                  <Award size={24} />
                </div>
                <div className="cert-info">
                  <h4>ISSA Certified</h4>
                  <p>Personal Trainer</p>
                </div>
              </div>
              <div className="cert-card">
                <div className="cert-icon">
                  <Target size={24} />
                </div>
                <div className="cert-info">
                  <h4>10+ Years</h4>
                  <p>Training Experience</p>
                </div>
              </div>
              <div className="cert-card">
                <div className="cert-icon">
                  <GraduationCap size={24} />
                </div>
                <div className="cert-info">
                  <h4>Specialized</h4>
                  <p>Nutrition & Programming</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
